/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import stockService from './../../../../services/stock';
import stockTransformer from './../../../../transformers/stock';
import warehouseService from './../../../../services/warehouse';
import productService from './../../../../services/product';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        warehouseId: {
          value: '',
          type: 'select',
        },
        transactionDate: {
          value: new Date(),
          type: 'date',
          attributes: {
            datePickerOptions: {
              disabledDate: this.disabledDate,
            },
          },
        },
        descriptions: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        physicalCount: {
          value: '0',
          type: 'number',
        },
        currentCount: {
          value: '0',
          type: 'number',
          disabled: true,
        },
        variance: {
          value: '0',
          type: 'number',
          disabled: true,
        },
      },
      isImport: true,
      isExport: true,
      download: this.downloadProduct,
      server: {
        url: '',
      },
    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      warehouses: 'allWarehouses',
    }),

    additionalData() {
      const Obj = Object.create({});
      Obj.fromWarehouseId = this.formBasicInformation.warehouseId;
      return Obj;
    },
  },

  watch: {
    warehouses(warehouses) {
      const data = warehouses.items.filter(item => !item.isSharedToYou);
      this.formBasicInformation.setOptions('warehouseId', data.map(item => ({ id: item.id, name: item.name + (item.isLocked ? this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked })
       ));
    },
    'formBasicInformation.warehouseId': function (warehouseId) {
      this.server = {
        url: `${process.env.API_LOCATION}/stocks/${this.formBasicInformation.warehouseId}/import-product?token=${localStorage.getItem('id_token')}`,
        process: {
          onload: (res) => {
            const name = 'inventory.stock.edit';
            // select the right value in the response here and return
            // return res;
            const obj = JSON.parse(res);
            console.log(obj);
            this.$router.push({
              name,
              params: { id: obj.id },
            });
          },
        },
      };
      store.dispatch('setStockSelectedWarehouse', warehouseId);
    },

    $route() {
      this.warehouseTarget();
    },
  },

  created() {
    this.loading = false;
  },

  methods: {

    disabledDate(date) {
      const nextDate = date.setDate(date.getDate());
      const prevDate = date.setDate(date.getDate() + 350);
      return prevDate < new Date() || nextDate > new Date();
    },

    warehouseTarget() {
      const warehouseIds = this.warehouses.items.map(item => (item.id));
      const targeId = this.$router.currentRoute.hash.substring(1);
      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
        this.formBasicInformation.setFieldValue('warehouseId', targeId);
      }
    },

    /**
     * Method to store stock data.
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = stockTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );

      stockService.store(client)
        .then(() => {
          this.$message({
            message: this.$t('static.stock.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.stock.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    /**
     * Method to save stock draft.
     * @return {[type]} [description]
     */
    saveDraft() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = stockTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );

      stockService.saveDraft(client)
        .then(() => {
          this.$message({
            message: this.$t('static.stock.draft.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.stock.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    downloadProduct() {
      console.log('clicked');
      stockService.downloadProduct(this.formBasicInformation.warehouseId);
    },
    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
  },
  mounted() {
    store.dispatch('allCurrentStockProductsCustom', []);
    Promise.all([
      warehouseService.all(),
    ]).then(() => {
      store.dispatch('setStockSelectedWarehouse', 0);
      this.warehouseTarget();
    });

    this.server = {
      url: `${process.env.API_LOCATION}/stocks/${this.formBasicInformation.warehouseId}?token=${localStorage.getItem('id_token')}`,

    };
  },
  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VProductsTable: require('./../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/stock/create/create.js